module.exports = __webpack_public_path__ + "static/media/close-color.a9d23fe5.svg";